import { getFieldComponents, getFieldComponentTargets } from './componentClasses';

const LEGACY_STYLE_KEYS = {
    wrapper: 'styleWrapper',
    label: 'styleLabel',
    description: 'styleDescription',
    control: 'styleInput'
};

export function getFieldComponentStyleKey(componentId) {
    return LEGACY_STYLE_KEYS[componentId] || 'styleComponent_' + componentId;
}

export function parseFieldStyles(item) {
    if (item == null || item.Style == null || item.Style.trim() == '') {
        return {};
    }

    try {
        return JSON.parse(item.Style) || {};
    } catch (e) {
        return {};
    }
}

export function hasFieldComponentStyles(item) {
    const styles = parseFieldStyles(item);
    return getFieldComponents(item).some(component => {
        const value = styles[getFieldComponentStyleKey(component.id)];
        return typeof value === 'string' && value.trim() != '';
    });
}

export function applyFieldComponentStyles(item) {
    if (item == null || item.Style == null || item.Style.trim() == '') {
        return;
    }

    const styles = parseFieldStyles(item);
    getFieldComponents(item).forEach(component => {
        const styleKey = getFieldComponentStyleKey(component.id);
        const style = styles[styleKey];
        if (typeof style !== 'string' || style.trim() == '') {
            return;
        }

        // Stilurile legacy pentru wrapper, etichetă, descriere și control sunt deja
        // randate prin _getWrapperStyle/_getLabelStyle/_getDescriptionStyle/_getInputStyle.
        if (LEGACY_STYLE_KEYS[component.id] != null) {
            return;
        }

        const resolved = getFieldComponentTargets(item, component);
        if (resolved.widget != null && !resolved.widget._xpComponentStylesBound) {
            resolved.widget._xpComponentStylesBound = true;
            resolved.widget.bind('dataBound', () => applyFieldComponentStyles(item));
            resolved.widget.bind('open', () => applyFieldComponentStyles(item));
        }

        resolved.targets.forEach(target => {
            if (target.__xpComponentStyles == null) {
                target.__xpComponentStyles = {};
            }
            if (target.__xpComponentStyles[styleKey] === style) {
                return;
            }

            target.style.cssText += (target.style.cssText.trim() != '' && !target.style.cssText.trim().endsWith(';') ? ';' : '') + style;
            target.__xpComponentStyles[styleKey] = style;
        });
    });
}
